import styles from './GooglePostPreview.pcss'
import { PostPreviewDefaultHeader } from './PostPreviewDefaultHeader'
import PostPreviewText from './PostPreviewText'
import { GooglePostButtonType } from 'shared/types'

const MAX_LINES = 4
const TRUNCATE_TEXT = 'more'
const COLLAPSE_TEXT_LABEL = 'less'

interface GooglePostPreviewProps {
  profile?: { name: string, image: string }
  featuredImageUrl?: string
  statusText?: string
  empty?: boolean
  buttonType?: GooglePostButtonType
  buttonLink?: string
}

const labels = {
  BOOK: 'BOOK',
  ORDER: 'ORDER ONLINE',
  SHOP: 'BUY',
  LEARN_MORE: 'LEARN MORE',
  SIGN_UP: 'SIGN UP',
  CALL: 'CALL'
}

export function GooglePostPreview(props: GooglePostPreviewProps) {
  const isEmpty = props.empty || (!props.statusText && !props.featuredImageUrl)

  return (
    <div
      data-testid="google-post-preview"
      className={`${styles.post} ${!props.featuredImageUrl ? styles['no-img'] : ''} ${isEmpty ? styles.empty : ''}`}
    >
      <PostPreviewDefaultHeader profile={props.profile} />
      {props.featuredImageUrl && (
        <div className={styles['img-box']}>
          <img src={props.featuredImageUrl} />
        </div>
      )}
      {isEmpty && <div className={styles['img-box']}></div>}
      <footer className={`${styles.footer} ${!props.statusText ? styles['text-empty'] : ''}`}>
        {props.statusText && (
          <PostPreviewText
            text={props.statusText || ''}
            maxLinesDefault={MAX_LINES}
            expandLabel={TRUNCATE_TEXT}
            collapseLabel={COLLAPSE_TEXT_LABEL}
            className={styles['g-text']}
          />
        )}
        {props.buttonType && (
          <a href={props.buttonLink} target="_blank" className={styles['g-btn']}>
            {labels[props.buttonType]}
          </a>
        )}
      </footer>
    </div>
  )
}
